export default {
    procedures: state => state.procedures,
    proceduresLoading: state => state.proceduresLoading
};
